module.exports = __webpack_public_path__ + "img/8th-grade-en.fd903f2c.png";